import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import './AuthModal.css';

export default function ChangePasswordModal({ onClose }) {
  const { changePassword } = useAuth();
  const [form, setForm] = useState({ current: '', newPass: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const update = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (form.newPass !== form.confirm) return setError('Passwords do not match');
    if (form.newPass.length < 8) return setError('Min 8 characters');
    setLoading(true);
    try {
      await changePassword(form.current, form.newPass);
      setSuccess('Password changed successfully!');
      setTimeout(onClose, 1500);
    } catch (err) {
      setError(err.message || 'Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="auth-modal">
        <button className="auth-close" onClick={onClose}>✕</button>
        <div className="auth-logo">📍 Spaczo</div>
        <h2 className="auth-title">Change Password</h2>
        <p className="auth-subtitle">Enter your current password and choose a new one</p>

        <form onSubmit={handleSubmit} className="auth-form" style={{marginTop: 16}}>
          <div className="auth-field">
            <label>Current Password</label>
            <input type="password" placeholder="Your current password" value={form.current} onChange={e => update('current', e.target.value)} required />
          </div>
          <div className="auth-field">
            <label>New Password</label>
            <input type="password" placeholder="Min 8 characters" value={form.newPass} onChange={e => update('newPass', e.target.value)} required minLength={8} />
          </div>
          <div className="auth-field">
            <label>Confirm New Password</label>
            <input type="password" placeholder="Repeat new password" value={form.confirm} onChange={e => update('confirm', e.target.value)} required minLength={8} />
          </div>

          {error   && <div className="auth-error">{error}</div>}
          {success && <div className="auth-success">{success}</div>}

          <button type="submit" className="auth-submit" disabled={loading}>
            {loading
              ? <span className="spinner" style={{ width: 18, height: 18, borderColor: 'rgba(255,255,255,0.3)', borderTopColor: '#fff' }} />
              : 'Change Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
